import { Route } from 'react-router-dom';
import { Main } from './main';

import { Vehiculos } from '../../vehicles/pages/vehiculos/vehiculos';
import { VehiculosEdit } from '../../vehicles/pages/vehiculos/vehiculos-edit';
import { Centros } from '../../vehicles/pages/centros/centros';
import { TiposMantenimiento } from '../../vehicles/pages/tipos-mantenimiento/tipos-mantenimiento';
import { EstadosItv } from '../../vehicles/pages/estados-itv/estados-itv';
import { CompaniaAseguradora } from '../../vehicles/pages/compania-aseguradora/compania-aseguradora';
import { Poliza } from '../../vehicles/pages/poliza/poliza';
import { TiposMultas } from '../../vehicles/pages/tipos-multas/tipos-multas';
import { EstadosMultas } from '../../vehicles/pages/estados-multa/estados-multa';
import { Conductores } from '../../vehicles/pages/conductores/conductores';
import { ConductoresEdit } from '../../vehicles/pages/conductores/conductores-edit';
import { ConductoresCreate } from '../../vehicles/pages/conductores/conductores-create';
import { Asignaciones } from '../../vehicles/pages/asignaciones/asignaciones';
import { AsignacionesCreate } from '../../vehicles/pages/asignaciones/asignaciones-create';
import { AsignacionesEdit } from '../../vehicles/pages/asignaciones/asignaciones-edit';
import { AsignacionesRelease } from '../../vehicles/pages/asignaciones/asignaciones-release';
import { VehiculosCreate } from '../../vehicles/pages/vehiculos/vehiculos-create';
import { Responsables } from '../../vehicles/pages/responsables/responsables';
import { MenuContainer } from '../../layouts/MenuContainer';
import { Usuarios } from '../../vehicles/pages/usuarios/usuarios';
import { MarcasPage } from '../../vehicles/pages/marcas';
import { ModelosPage } from '../../vehicles/pages/modelos';
import { RentingCompanies } from '../../vehicles/pages/renting-companies/renting-companies';
import { Providers } from '../../vehicles/pages/providers';
import { Devices } from '../../vehicles/pages/devices/devices';
import { DeviceDetail } from '../../vehicles/pages/devices/device-detail';
import { Home } from '../../vehicles/pages/home';
import { MapaGpsDia } from '../mapa-gps-dia/mapa-gps-dia';
import { MileageControl } from '../mileage-control/mileage-control';
import { Jobs } from '../../vehicles/pages/jobs/jobs';
import { JobsOptimization } from '../../vehicles/pages/job-optimization/job-optimization';
import { Shipments } from '../../vehicles/pages/shipments/shipments';
import { ShipmentsCreate } from '../../vehicles/pages/shipments/shipments-create';
import { ShipmentsEdit } from '../../vehicles/pages/shipments/shipments-edit';
import { FuelConsumption } from '../fuel-consumption/fuel-consumption';
import { DetectedRefuelings } from '../detected-refuelings/detected-refuelings';
import { AggressiveDrivingEvents } from '../aggressive-driving-events/aggressive-driving-events';
import { Trips } from '../trips/trips';
import { TripDetail } from '../trips/trip-detail';
import { Dashboard2 } from '../dashboard2';
import { HomeBody } from '../../vehicles/pages/home/home-body';
import { CreateRoute } from '../../vehicles/pages/create-route';
import { RoutesComponents } from '../../vehicles/pages/routes/routes';
import { RoutesDetail } from '../../vehicles/pages/routes/routes-detail';
import { RoutesConfig } from '../../vehicles/pages/routes-config/routes-config';
import { RoutesConfigCreate } from '../../vehicles/pages/routes-config/routes-config-create';
import { RoutesConfigEdit } from '../../vehicles/pages/routes-config/routes-config-edit';
import { RutasRealizadas } from '../../vehicles/pages/rutas-realizadas/rutas-relizadas';
import { CustomersMap, CustomersTable } from '../../vehicles/pages/customers';
import { CustomersEdit } from '../../vehicles/pages/customers/customers-edit';
import { CustomersCreate } from '../../vehicles/pages/customers/customers-create';
import { SaleRepresentatives } from '../../vehicles/pages/sale-representatives';
import { UpdateCustomers } from '../../vehicles/pages/update-customers/update-customers';
import { Areas } from '../../vehicles/pages/areas';





export const MainRouter = () => {
    return (
        <Route path="/" element={<MenuContainer />}>
            <Route element={<Main />}>
                {/* <Route index element={<Vehiculos />} />
                <Route path="/">
                    <Route index element={<Vehiculos />} />
                    <Route path=":id" element={<VehiculosEdit />} />
                    <Route path="create" element={<VehiculosCreate />} />
                </Route> */}

                <Route index element={<Home />} />
                <Route path="/" element={<Home />} />
                <Route path="realtime-map" element={<HomeBody />} />

                <Route path="vehicles">
                    <Route index element={<Vehiculos />} />
                    <Route path=":id" element={<VehiculosEdit />} />
                    <Route path="create" element={<VehiculosCreate />} />
                </Route>
                <Route path="devices" element={<Devices />} />
                <Route path="devices/:id" element={<DeviceDetail />} />
                <Route path="day-gps-map" element={<MapaGpsDia />} />
                <Route path="mileage-control" element={<MileageControl />} />
                <Route path="fuel-consumption" element={<FuelConsumption />} />
                <Route path="detected-refuelings" element={<DetectedRefuelings />} />
                <Route path="aggressive-driving-events" element={<AggressiveDrivingEvents />} />
                <Route path="trips">
                    <Route index element={<Trips />} />
                    <Route path=":id" element={<TripDetail />} />
                </Route>
                <Route path="dashboard2" element={<Dashboard2 />} />
                <Route path="drivers">
                    <Route index element={<Conductores />} />
                    <Route path=":id" element={<ConductoresEdit />} />
                    <Route path="create" element={<ConductoresCreate />} />
                </Route>
                <Route path="assignments">
                    <Route index element={<Asignaciones />} />
                    <Route path="create" element={<AsignacionesCreate />} />
                    <Route path=":id" element={<AsignacionesEdit />} />
                    <Route path="release" element={<AsignacionesRelease />} />
                </Route>
                <Route path="centers" element={<Centros />} />
                <Route path="jobs" element={<Jobs />} />
                <Route path="shipments">
                    <Route index element={<Shipments />} />
                    <Route path="create" element={<ShipmentsCreate />} />
                    <Route path=":id" element={<ShipmentsEdit />} />
                </Route>
                <Route path="job-optimization" element={<JobsOptimization />} />
                <Route path="maintenance-types" element={<TiposMantenimiento />} />
                <Route path="inspections-statuses" element={<EstadosItv />} />
                <Route path="insurance-company" element={<CompaniaAseguradora />} />
                {/*   <Route path="poliza" element={<Poliza />} /> */}
                <Route path="fine-types" element={<TiposMultas />} />
                <Route path="fine-statuses" element={<EstadosMultas />} />
                <Route path="responsibles" element={<Responsables />} />
                <Route path="users" element={<Usuarios />} />
                <Route path="brands" element={<MarcasPage />} />
                <Route path="models" element={<ModelosPage />} />
                <Route path="renting-companies" element={<RentingCompanies />} />
                <Route path="providers" element={<Providers />} />

                <Route path="create-route" element={<CreateRoute />} />
                <Route path="routes">
                    <Route index element={<RoutesComponents />} />
                    <Route path=":id" element={<RoutesDetail />} />
                    {/*  <Route path="create" element={<ShipmentsCreate />} />
                    <Route path=":id" element={<ShipmentsEdit />} /> */}
                </Route>
                <Route path="route-configs">
                    <Route index element={<RoutesConfig />} />
                    <Route path="create" element={<RoutesConfigCreate />} />
                    <Route path=":id" element={<RoutesConfigEdit />} />
                </Route>
                <Route path="routes-taken" element={<RutasRealizadas onAction={() => { }} />} />
                <Route path="areas" element={<Areas />} />
                <Route path="customers">
                    <Route index element={<CustomersTable />} />
                    <Route path="map" element={<CustomersMap />} />
                    <Route path=":id" element={<CustomersEdit />} />
                    <Route path="create" element={<CustomersCreate />} />
                </Route>
                <Route path="sale-representatives" element={<SaleRepresentatives />} />
                <Route path="update-customers" element={<UpdateCustomers />} />
            </Route>
        </Route>
    );
};